export enum LS_KEYS {
    tmpPasswordEmail = 'tmpPasswordEmail',
    showTmpPasswordContactUs = 'showTmpPasswordContactUs',
    uuid = 'uuid',
    isUserFirstTimeOnMainPageAfterOB = 'isUserFirstTimeOnMainPageAfterOB',
    appAccessCode = 'appAccessCode',
    language = 'language',
    SOURCE = 'source',
    UTM_SOURCE = 'utmSource',
}

export const getLocalStorageKey = (key: string, defaultValue: any) => {
    try {
        const value = localStorage.getItem(key);

        return value ? JSON.parse(value) : defaultValue;
    } catch {
        return defaultValue;
    }
};
